import { useEffect, useState } from "react";
import { ChevronDown, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { GlassCard, EmptyState, fmtMoney } from "@/components/erp";
import { DURUM, Rozet } from "@/lib/perms";
import api, { errMsg } from "@/lib/api";

const tarih = (d) => (d ? new Date(d).toLocaleDateString("tr-TR") : "—");

const Takip = ({ t, testid }) => (
  <div className="flex items-center gap-3 text-xs" data-testid={testid}>
    <span className={t.durum === "uretimde" ? "text-violet-300" : t.durum === "sevk" || t.durum === "hazir" ? "text-emerald-300" : "text-muted-foreground"}>{t.metin}</span>
    {t.ilerleme != null && <div className="flex-1 max-w-[160px] h-1.5 rounded-full bg-white/10 overflow-hidden"><div className="h-full grad-bg" style={{ width: `${t.ilerleme}%` }} /></div>}
  </div>
);

const Siparis = ({ s, onTekrar }) => {
  const [acik, setAcik] = useState(false);
  const tekrar = () => {
    const uygun = s.kalemler.filter((k) => k.satista);
    if (!uygun.length) { toast.error("Bu siparişteki ürünlerin hiçbiri artık satışta değil"); return; }
    onTekrar(uygun.map((k) => ({ id: k.urun_id, kod: k.kod, ad: k.ad, miktar: k.miktar })));
    const eksik = s.kalemler.length - uygun.length;
    toast.success(`${uygun.length} ürün sepete eklendi${eksik ? `, ${eksik} ürün artık satışta olmadığı için eklenmedi` : ""}. Miktarları sepette değiştirebilirsiniz.`);
  };
  return (
    <GlassCard className="p-4" data-testid={`bayi-siparis-${s.no}`}>
      <button onClick={() => setAcik(!acik)} className="w-full flex flex-wrap items-center gap-x-4 gap-y-2 text-left" data-testid={`bayi-siparis-ac-${s.no}`}>
        <span className="font-mono text-sm">{s.no}</span>
        <span className="text-xs text-muted-foreground">{tarih(s.tarih)}</span>
        <Rozet map={DURUM} d={s.durum} testid={`bayi-siparis-durum-${s.no}`} />
        <span className="text-xs text-muted-foreground">Termin: {tarih(s.onerilen_termin || s.termin_tarihi)}</span>
        {s.kalan_gun != null && <span data-testid={`bayi-kalan-gun-${s.no}`} className={`text-xs ${s.kalan_gun < 0 ? "text-red-300" : "text-amber-200"}`}>
          {s.kalan_gun > 0 ? `Termine ${s.kalan_gun} gün kaldı` : s.kalan_gun === 0 ? "Termin bugün" : `Termin ${-s.kalan_gun} gün geçti`}</span>}
        <span className="ml-auto font-mono font-semibold">{fmtMoney(s.genel_toplam, s.para_birimi)}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${acik ? "rotate-180" : ""}`} />
      </button>
      {acik && (
        <div className="mt-3 pt-3 border-t border-white/5 space-y-1.5 text-sm">
          {s.kalemler.map((k, i) => (
            <div key={i} className="space-y-1" data-testid={`bayi-kalem-${s.no}-${k.kod}`}>
              <div className="grid grid-cols-12 gap-2">
                <span className="col-span-7 truncate"><span className="font-mono text-xs text-muted-foreground mr-2">{k.kod}</span>{k.ad}</span>
                <span className="col-span-2 text-right font-mono">{k.miktar}</span>
                <span className="col-span-3 text-right font-mono">{fmtMoney(k.tutar, s.para_birimi)}</span>
              </div>
              {k.takip && <Takip t={k.takip} testid={`bayi-takip-${s.no}-${k.kod}`} />}
            </div>
          ))}
          {s.notlar && <p className="text-xs text-muted-foreground pt-1">Not: {s.notlar}</p>}
        </div>
      )}
      <button data-testid={`bayi-tekrar-${s.no}`} onClick={tekrar} className="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs bg-white/10 hover:bg-white/15 transition-colors">
        <RotateCcw className="w-3.5 h-3.5" />Tekrar sipariş ver</button>
    </GlassCard>
  );
};

export const BayiSiparisler = ({ onTekrar }) => {
  const [list, setList] = useState(null);
  const [hata, setHata] = useState("");
  useEffect(() => { api.get("/bayi/siparisler").then((r) => setList(r.data)).catch((e) => setHata(errMsg(e))); }, []);
  if (hata) return <p className="text-sm text-red-300" data-testid="bayi-siparis-hata">{hata}</p>;
  if (!list) return null;
  if (!list.length) return <EmptyState text="Henüz siparişiniz yok." testid="bayi-siparis-bos" />;
  return <div className="space-y-3" data-testid="bayi-siparisler">{list.map((s) => <Siparis key={s.id} s={s} onTekrar={onTekrar} />)}</div>;
};
